import namespace from '../../config/Namespace';

const types = {
  actions: {
    fetchNotes: 'fetchNotes',
    fetchNotesSuccess: 'fetchNotesSuccess',
    fetchNoteDetails: 'fetchNoteDetails',
    fetchNoteDetailsSuccess: 'fetchNoteDetailsSuccess',
  },
};

export default namespace('Notes', types);
